import { apiHandler } from "api";
import { endpoint } from "api/endpoint";
import Product from "component/Product/Product";
import { useState, useCallback, useRef, useMemo } from "react";
import OwlCarousel from "react-owl-carousel";
import CategoryPlaceholder from "asset/image/CategoryPlaceholder.png";

const PAGE_SIZE = 8;

const fetchProducts = async (page) => {
  const res = await apiHandler({
    url: `${endpoint.NEW_ARRIVALS}?limit=${PAGE_SIZE}&page=${page}`,
    method: "GET",
  });
  return res.data;
};

const NewArrivalSlider = ({ newArrivals, totalNewArrivals }) => {
  const [newArrivalProducts, setNewArrivalProducts] = useState([
    ...newArrivals,
  ]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const loadingRef = useRef(false);
  const carouselRef = useRef(null);
  const startPosition = useRef(0);

  const loadMore = useCallback(async () => {
    if (
      !hasMore ||
      loadingRef.current ||
      newArrivalProducts.length >= totalNewArrivals
    )
      return;
    loadingRef.current = true;
    setLoading(true);
    const newPage = page + 1;
    try {
      const result = await fetchProducts(newPage);
      const newProducts = result[0]["data"];
      const totalProducts = result[0]["total_count"];
      setNewArrivalProducts((prev) => [...prev, ...newProducts]);
      setHasMore(newProducts.length < totalProducts);
      setPage((prev) => prev + 1);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
      loadingRef.current = false;
    }
  }, [page, loading, hasMore, newArrivalProducts.length, totalNewArrivals]);

  const handleSlideChange = (event) => {
    const lastVisibleIndex = event.item.index + event.page.size;
    if (lastVisibleIndex >= newArrivalProducts.length - 2 && hasMore) {
      startPosition.current = event.item.index;
      loadMore();
    }
  };

  const ProductSlides = useMemo(() => {
    return newArrivalProducts.map((product, index) => (
      <div key={index} style={{ padding: "10px" }}>
        <Product
          productname={product.name}
          imageUrl={product.image_url}
          available_color={product.available_color}
          urlKey={product.url_key}
          productId={product.id}
          code={product.sku}
          isNew={product.is_new}
          productdiscription={product.description}
          productprice={product.price}
          productimages={product.image}
          logoflagcomponent={
            product.germfree_non_germ_free === "GF" ? true : false
          }
          logoInternationalcompo={
            product.international_non_internationa === "JI" ? true : false
          }
          imageALT={product.image_alt}
        />
      </div>
    ));
  }, [newArrivalProducts]);

  return (
    <OwlCarousel
      ref={carouselRef}
      className="grid productcategories owl-carousel owl-theme"
      responsive={{
        0: {
          items: 1,
        },
        600: {
          items: 2,
        },
        1000: {
          items: 4,
        },
      }}
      items={4}
      nav
      dots={false}
      onChanged={handleSlideChange}
      startPosition={startPosition.current}
    >
      {newArrivalProducts && newArrivalProducts.length
        ? ProductSlides
        : Array.from(Array(2).keys()).map((e) => (
            <div key={e}>
              <figure
                className="effect-moses"
                style={{ background: "transparent" }}
              >
                <img
                  src={CategoryPlaceholder}
                  alt=""
                  loading="lazy"
                  width={398}
                  height={459}
                />
              </figure>
            </div>
          ))}
    </OwlCarousel>
  );
};

export default NewArrivalSlider;
